import React from 'react'
import { Form, Header, Input } from 'semantic-ui-react'
import CountryDropdown from '../CountryDropdown'
import TimeZone from '../TimeZone'

export const DEFAULT_GENERAL_INFO = {
  first_name: '',
  last_name: '',
  country: '',
}

const General = ({ profile, setProfile, skipHeader, skipTimeZone }) => (
  <div id="general-section">
    {!skipHeader && <Header as="h4">General Information</Header>}
    <div className="content">
      <Form>
        <Form.Group>
          <Form.Field required width={8}>
            <label>First Name</label>
            <Input
              placeholder="First Name"
              value={profile.first_name}
              onChange={(e, { value }) =>
                setProfile({ ...profile, first_name: value })
              }
            />
          </Form.Field>
          <Form.Field required width={8}>
            <label>Last Name</label>
            <Input
              placeholder="Last Name"
              value={profile.last_name}
              onChange={(e, { value }) =>
                setProfile({ ...profile, last_name: value })
              }
            />
          </Form.Field>
        </Form.Group>
        <Form.Field required id="country-field">
          <label>Country</label>
          <CountryDropdown
            defaultCountry={profile.country}
            setCountry={(country) => setProfile({ ...profile, country })}
          />
        </Form.Field>
        {!skipTimeZone && (
          <Form.Field required>
            <label>Time zone</label>
            <TimeZone />
          </Form.Field>
        )}
      </Form>
    </div>
  </div>
)

export default General
